/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ci_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Everything is analyzed in your browser; your text is never sent to a server.`)
};

const es_ci_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Todo se analiza en tu navegador; tu texto nunca se envía a un servidor.`)
};

const de_ci_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Alles wird in Ihrem Browser analysiert; Ihr Text wird niemals an einen Server gesendet.`)
};

const nl_ci_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Alles wordt in je browser geanalyseerd; je tekst wordt nooit naar een server verzonden.`)
};

const fr_ci_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Tout est analysé dans votre navigateur ; votre texte n'est jamais envoyé à un serveur.`)
};

const it_ci_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Tutto viene analizzato nel tuo browser; il tuo testo non viene mai inviato a un server.`)
};

const pt_br2_ci_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Tudo é analisado no seu navegador; seu texto nunca é enviado para um servidor.`)
};

const pt_ci_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Tudo é analisado no seu navegador; o seu texto nunca é enviado para um servidor.`)
};

const ja_ci_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「いいえ。すべてがブラウザで分析され、テキストがサーバーに送信されることはありません。」`)
};

const zh_ci_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。所有分析都在您的浏览器中完成；您的文本永远不会发送到服务器。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ci_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ci_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ci_faq3_a", locale)
	if (locale === "en") return en_ci_faq3_a(inputs)
	if (locale === "es") return es_ci_faq3_a(inputs)
	if (locale === "de") return de_ci_faq3_a(inputs)
	if (locale === "nl") return nl_ci_faq3_a(inputs)
	if (locale === "fr") return fr_ci_faq3_a(inputs)
	if (locale === "it") return it_ci_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_ci_faq3_a(inputs)
	if (locale === "pt") return pt_ci_faq3_a(inputs)
	if (locale === "ja") return ja_ci_faq3_a(inputs)
	return zh_ci_faq3_a(inputs)
};